/**
 * Mock Feedback API
 *
 * Provides provider feedback data from mockDb for development.
 */

import type { ProviderFeedback, ApiResponse } from '../types'
import { mockDb, delay } from './mockDb'
import { success } from './client'

export const feedbackApi = {
  async getVendorFeedback(vendorId: string): Promise<ApiResponse<ProviderFeedback[]>> {
    await delay(100)
    const all = mockDb.getAll<ProviderFeedback>('providerFeedback')
    const filtered = all.filter((f) => f.vendorId === vendorId)
    return success(filtered)
  },

  async submitFeedback(
    data: Omit<ProviderFeedback, 'id' | 'createdAt' | 'updatedAt'>
  ): Promise<ApiResponse<ProviderFeedback>> {
    await delay(100)
    const entry = mockDb.insert<ProviderFeedback>('providerFeedback', data)
    return success(entry)
  },
}
